import RecruitHeroSection from "./components/RecruitHeroSection";
import RecruitIntroSection from "./components/RecruitIntroSection";
import RecruitMessageSection from "./components/RecruitMessageSection";
import RecruitWhySection from "./components/RecruitWhySection";
import RecruitOfficeSection from "./components/RecruitOfficeSection";
import RecruitValueSection from "./components/RecruitValueSection";
import RecruitTrainingSection from "./components/RecruitTrainingSection";
import RecruitDayInLifeSection from "./components/RecruitDayInLifeSection";
import RecruitJobDetailsSection from "./components/RecruitJobDetailsSection";
import RecruitApplyCtaSection from "./components/RecruitApplyCtaSection";
import RecruitFloatingCta from "./components/RecruitFloatingCta";
import FaqSection from "@/components/feature/FaqSection";
import { useSeo } from "@/hooks/useSeo";

const recruitFaq = [
  {
    question: "警備の仕事は未経験でも働けますか？",
    answer: "はい、未経験歓迎です。座学研修・実技研修・OJT研修の3ステップで丁寧に指導します。研修費用は会社負担です。",
  },
  {
    question: "日払いはできますか？",
    answer: "はい、日払い・週払いに対応しています。",
  },
  {
    question: "シニアでも働けますか？",
    answer: "はい、シニア歓迎です。現在50代・60代のスタッフが多数活躍しています。",
  },
  {
    question: "給与はどのくらいですか？",
    answer: "交通誘導スタッフは日給10,000円〜、高速道路警備スタッフは日給14,000〜20,000円です。",
  },
];

export default function Recruit() {
  useSeo({
    title: "警備スタッフ募集・アルバイト求人 大阪 未経験歓迎 | 株式会社GRANSTARK",
    description:
      "大阪・関西エリアの警備会社GRANSTARKでアルバイト・バイト・正社員を募集中。未経験・シニア歓迎。日払い対応。交通誘導・イベント・高速道路警備のお仕事です。まずはお気軽にご応募ください。",
    ogTitle: "警備スタッフ募集・アルバイト求人 大阪 | GRANSTARK",
    ogDescription:
      "大阪・関西エリアの警備会社GRANSTARKでアルバイト・バイト・正社員を募集中。未経験・シニア歓迎。日払い対応。交通誘導・イベント・高速道路警備のお仕事です。まずはお気軽にご応募ください。",
    ogUrl: "https://www.gs-granstark.com/recruit",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://www.gs-granstark.com/recruit#webpage",
        url: "https://www.gs-granstark.com/recruit",
        name: "警備スタッフ募集・アルバイト求人 大阪 未経験歓迎 | 株式会社GRANSTARK",
        description:
          "大阪・関西エリアの警備会社GRANSTARKでアルバイト・バイト・正社員を募集中。未経験・シニア歓迎。日払い対応。交通誘導・イベント・高速道路警備のお仕事です。まずはお気軽にご応募ください。",
        isPartOf: { "@id": "https://www.gs-granstark.com/#website" },
        publisher: { "@id": "https://www.gs-granstark.com/#business" },
        inLanguage: "ja",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: recruitFaq.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        title: "警備スタッフ（アルバイト・正社員）",
        description:
          "大阪・関西エリアでの交通誘導・イベント・高速道路警備のお仕事です。未経験・シニア歓迎。",
        employmentType: ["FULL_TIME", "PART_TIME"],
        hiringOrganization: {
          "@type": "Organization",
          name: "株式会社GRANSTARK",
          sameAs: "https://www.gs-granstark.com",
        },
        jobLocation: {
          "@type": "Place",
          address: {
            "@type": "PostalAddress",
            addressLocality: "大阪市",
            addressRegion: "大阪府",
            addressCountry: "JP",
          },
        },
        datePosted: "2026-05-01",
        validThrough: "2026-12-31",
      },
    ],
  });

  return (
    <div className="pb-20 md:pb-16">
      <RecruitHeroSection />
      <RecruitIntroSection />
      <RecruitMessageSection />
      <RecruitWhySection />
      <RecruitOfficeSection />
      <RecruitValueSection />
      <RecruitTrainingSection />
      <RecruitDayInLifeSection />
      <RecruitJobDetailsSection />
      <RecruitApplyCtaSection />
      <FaqSection items={recruitFaq} bgColor="bg-gray-50" />
      <RecruitFloatingCta />
    </div>
  );
}
